<div class="customers-page">
  <mat-tab-group
    [(selectedIndex)]="matTabIndex"
    (selectedIndexChange)="updateUrl($event)"
    animationDuration="0ms"
    disableRipple
    class="customers-page__tabs"
  >
    @for (section of sections; track trackByIndex) {
      <mat-tab>
        @switch (section) {
          @case (CrmSection.Lead) {
            <ng-template mat-tab-label>
              <div class="customers-page__tab-label">
                <app-icon name="lead"></app-icon>
                <span>{{ "CRM.customersAndLead.lead" | translate }}</span>
              </div>
            </ng-template>

            @if (crmSection === CrmSection.Lead) {
              <div class="customers-page__section">
                <div class="customers-page__toolbar">
                  <button
                    mat-button
                    class="customers-page__filter-toggle"
                    (click)="toggleFilters()"
                  >
                    <span class="customers-page__filter-toggle-icon">
                      @if (!filterExpanded) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                             fill="currentColor">
                          <path d="M7 10l5 5 5-5H7z"/>
                        </svg>
                      } @else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                             fill="currentColor">
                          <path d="M7 14l5-5 5 5H7z"/>
                        </svg>
                      }
                    </span>
                    <div class="customers-filter-card__title-block">
                      <span class="customers-filter-card__eyebrow font-walter">
                        {{ 'pages.catalogList.filters' | translate }}
                      </span>
                    </div>
                  </button>
                </div>

                <div class="customers-page__filter-shell" [@slideToggle]="filterExpanded ? 'visible' : 'hidden'">
                  @if (searchForm) {
                    <form class="customers-filter-card" [formGroup]="searchForm">
<!--                      <div class="customers-filter-card__header">-->
<!--                        <div class="customers-filter-card__title-block">-->
<!--                          <span class="customers-filter-card__eyebrow font-walter">-->
<!--                            Filtri-->
<!--                          </span>-->
<!--                          <h3 class="customers-filter-card__title">-->
<!--                            Lead-->
<!--                          </h3>-->
<!--                        </div>-->
<!--                      </div>-->

                      <div class="customers-filter-card__content">
                        <div class="customers-filter-card__group">
                          <label class="customers-filter-card__group-label">
                            {{ 'generics.cols.createDate' | translate }}
                          </label>

                          <div class="customers-filter-card__grid customers-filter-card__grid--dates"
                               formGroupName="createDate">
                            <app-input
                              [placeholder]="'generics.cols.from' | translate"
                              formControlName="from"
                              type="date"
                            ></app-input>

                            <app-input
                              [placeholder]="'generics.cols.to' | translate"
                              formControlName="to"
                              type="date"
                            ></app-input>
                          </div>
                        </div>

                        <div class="customers-filter-card__grid customers-filter-card__grid--filters">
                          <app-input
                            [label]="'generics.cols.name' | translate"
                            formControlName="name"
                            type="text"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.email' | translate"
                            formControlName="email"
                            type="text"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.country' | translate"
                            formControlName="country"
                            type="selection"
                            [selectionOptions]="countrySelection"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.origin' | translate"
                            formControlName="origin"
                            type="selection"
                            [selectionOptions]="originSelection"
                          ></app-input>

                          <ng-container formGroupName="evaluation">
                            <app-input
                              [label]="'generics.cols.evaluation' | translate"
                              formControlName="value"
                              type="selection"
                              [selectionOptions]="evaluationSelectionLeads"
                            ></app-input>
                          </ng-container>

                          <app-input
                            [label]="'generics.cols.assignedTo' | translate"
                            formControlName="assignedTo"
                            type="selection"
                            [selectionOptions]="assignedToSelection"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.messagesToReadSelection' | translate"
                            formControlName="messagesToRead"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="messagesToReadSelection"
                          ></app-input>
                        </div>
                      </div>

                      <div class="customers-filter-card__footer">
                        <button
                          type="button"
                          class="customers-filter-card__btn customers-filter-card__btn--primary force-text-white"
                          (click)="doSearch()"
                        >

                          <span>{{ 'generics.cols.filter' | translate }}</span>
                        </button>

                        @if (!showUndo) {
                          <button
                            type="button"
                            class="customers-filter-card__btn customers-filter-card__btn--secondary"
                            (click)="clearFilter()"
                          >
                            <span>{{ 'generics.cols.includeWaste' | translate }}</span>
                          </button>
                        } @else {
                          <button
                            type="button"
                            class="customers-filter-card__btn customers-filter-card__btn--secondary"
                            (click)="clearFiltersAndDoSearch()"
                          >
                            <i class="icon-ipe-clear" aria-hidden="true"></i>
                            <span>{{ 'generics.cols.undo' | translate }}</span>
                          </button>
                        }
                      </div>
                    </form>
                  }
                </div>

                @if (actions) {
                  <div class="customers-page__table-shell">
                    <app-tree
                      (clickRow)="openRowDetail($event)"
                      [dataSource]="leads"
                      [columns]="['createDate', 'name', 'email', 'origin', 'country', 'evaluation', 'rating', 'assignedTo']"
                      [actions]="actions?.lead"
                      [widgetOptions]="widgetOptions"
                    ></app-tree>
                  </div>
                }
              </div>
            }
          }
          @case (CrmSection.VerifiedContact) {
            <ng-template mat-tab-label>
              <div class="customers-page__tab-label">
                <app-icon name="verified-contact"></app-icon>
                <span>{{ "CRM.customersAndLead.verifiedContacts" | translate }}</span>
              </div>
            </ng-template>

            @if (crmSection === CrmSection.VerifiedContact) {
              <div class="customers-page__section">
                <div class="customers-page__toolbar">
                  <button
                    mat-button
                    class="customers-page__filter-toggle"
                    (click)="toggleFilters()"
                  >
                    <span class="customers-page__filter-toggle-icon">
                      @if (!filterExpanded) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                             fill="currentColor">
                          <path d="M7 10l5 5 5-5H7z"/>
                        </svg>
                      } @else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                             fill="currentColor">
                          <path d="M7 14l5-5 5 5H7z"/>
                        </svg>
                      }
                    </span>
                    <div class="customers-filter-card__title-block">
                      <span class="customers-filter-card__eyebrow font-walter">
                        {{ 'pages.catalogList.filters' | translate }}
                      </span>
                    </div>
                  </button>

                  <div class="customers-page__toolbar-actions">
                    <button
                      type="button"
                      class="customers-filter-card__btn customers-filter-card__btn--primary force-text-white"
                      (click)="createCustomer()"
                    >
                      <i class="verified-contact-plus" aria-hidden="true"></i>
                      <span>{{ 'CREA_NUOVO' | translate }}</span>
                    </button>
                  </div>
                </div>

                <div class="customers-page__filter-shell" [@slideToggle]="filterExpanded ? 'visible' : 'hidden'">
                  @if (searchForm) {
                    <form class="customers-filter-card" [formGroup]="searchForm">
<!--                      <div class="customers-filter-card__header">-->
<!--                        <div class="customers-filter-card__title-block">-->
<!--                          <span class="customers-filter-card__eyebrow font-walter">-->
<!--                            Filtri-->
<!--                          </span>-->
<!--                          <h3 class="customers-filter-card__title">-->
<!--                            Contatti verificati-->
<!--                          </h3>-->
<!--                        </div>-->
<!--                      </div>-->

                      <div class="customers-filter-card__content">
                        <div class="customers-filter-card__group">
                          <label class="customers-filter-card__group-label">
                            {{ 'generics.cols.createDate' | translate }}
                          </label>

                          <div class="customers-filter-card__grid customers-filter-card__grid--dates"
                               formGroupName="createDate">
                            <app-input
                              [placeholder]="'generics.cols.from' | translate"
                              formControlName="from"
                              type="date"
                            ></app-input>

                            <app-input
                              [placeholder]="'generics.cols.to' | translate"
                              formControlName="to"
                              type="date"
                            ></app-input>
                          </div>
                        </div>

                        <div class="customers-filter-card__grid customers-filter-card__grid--filters">
                          <app-input
                            [label]="'generics.cols.name' | translate"
                            formControlName="name"
                            type="text"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.email' | translate"
                            formControlName="email"
                            type="text"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.country' | translate"
                            formControlName="country"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="allCountrySelection || []"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.origin' | translate"
                            formControlName="origin"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="allOriginSelection || []"
                          ></app-input>

                          <app-nested-tree
                            [label]="'generics.cols.jobTitle' | translate"
                            formControlName="jobTitle"
                            [showNullOption]="true"
                            [selectionOptions]="jobTitleSelection"
                          ></app-nested-tree>

                          <app-input
                            [label]="'generics.cols.customerChannel' | translate"
                            formControlName="customerChannel"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="customerChannelSelection || []"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.assignedTo' | translate"
                            formControlName="assignedTo"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="allAssignedToSelection || []"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.evaluation' | translate"
                            formControlName="evaluation"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="evaluationSelection"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.messagesToReadSelection' | translate"
                            formControlName="messagesToRead"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="messagesToReadSelection"
                          ></app-input>
                        </div>
                      </div>

                      <div class="customers-filter-card__footer">
                        <button
                          type="button"
                          class="customers-filter-card__btn customers-filter-card__btn--primary force-text-white force-text-white"
                          (click)="doSearch()"
                        >

                          <span>{{ 'generics.cols.filter' | translate }}</span>
                        </button>

                        <button
                          type="button"
                          class="customers-filter-card__btn customers-filter-card__btn--secondary"
                          (click)="clearFilter()"
                        >
                          <i class="icon-ipe-clear" aria-hidden="true"></i>
                          <span>{{ 'generics.cols.clean' | translate }}</span>
                        </button>
                      </div>
                    </form>
                  }
                </div>

                @if (actions) {
                  <div class="customers-page__table-shell">
                    <app-tree
                      (clickRow)="openRowDetail($event)"
                      [dataSourceObservable]="dataSourceVerifiedContacts"
                      [columns]="VerifiedContactsColumns"
                      [actions]="actions?.verifiedContacts"
                      [widgetOptions]="widgetOptions"
                    ></app-tree>
                  </div>
                }
              </div>
            }
          }
          @case (CrmSection.CustomerList) {
            <ng-template mat-tab-label>
              <div class="customers-page__tab-label">
                <app-icon name="client"></app-icon>
                <span>{{ "CRM.customersAndLead.customersList" | translate }}</span>
              </div>
            </ng-template>

            @if (crmSection === CrmSection.CustomerList) {
              <div class="customers-page__section">
                <div class="customers-page__toolbar">
                  <button
                    mat-button
                    class="customers-page__filter-toggle"
                    (click)="toggleFilters()"
                  >
                    <span class="customers-page__filter-toggle-icon">
                      @if (!filterExpanded) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                             fill="currentColor">
                          <path d="M7 10l5 5 5-5H7z"/>
                        </svg>
                      } @else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                             fill="currentColor">
                          <path d="M7 14l5-5 5 5H7z"/>
                        </svg>
                      }
                    </span>
                    <div class="customers-filter-card__title-block">
                      <span class="customers-filter-card__eyebrow font-walter">
                        {{ 'pages.catalogList.filters' | translate }}
                      </span>
                    </div>
                  </button>
                </div>

                <div class="customers-page__filter-shell" [@slideToggle]="filterExpanded ? 'visible' : 'hidden'">
                  @if (searchForm) {
                    <form class="customers-filter-card" [formGroup]="searchForm">
<!--                      <div class="customers-filter-card__header">-->
<!--                        <div class="customers-filter-card__title-block">-->
<!--                          <span class="customers-filter-card__eyebrow font-walter">-->
<!--                            Filtri-->
<!--                          </span>-->
<!--                          <h3 class="customers-filter-card__title">-->
<!--                            Clienti-->
<!--                          </h3>-->
<!--                        </div>-->
<!--                      </div>-->

                      <div class="customers-filter-card__content">
                        <div class="customers-filter-card__group">
                          <label class="customers-filter-card__group-label">
                            {{ 'generics.cols.createDate' | translate }}
                          </label>

                          <div class="customers-filter-card__grid customers-filter-card__grid--dates"
                               formGroupName="createDate">
                            <app-input
                              [placeholder]="'generics.cols.from' | translate"
                              formControlName="from"
                              type="date"
                            ></app-input>

                            <app-input
                              [placeholder]="'generics.cols.to' | translate"
                              formControlName="to"
                              type="date"
                            ></app-input>
                          </div>
                        </div>

                        <div class="customers-filter-card__grid customers-filter-card__grid--filters">
                          <app-input
                            label="Code"
                            formControlName="code"
                            type="text"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.name' | translate"
                            formControlName="name"
                            type="text"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.email' | translate"
                            formControlName="email"
                            type="text"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.country' | translate"
                            formControlName="country"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="allCountrySelection || []"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.origin' | translate"
                            formControlName="origin"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="allOriginSelection || []"
                          ></app-input>

                          <app-nested-tree
                            [label]="'generics.cols.jobTitle' | translate"
                            formControlName="jobTitle"
                            [showNullOption]="true"
                            [selectionOptions]="jobTitleSelection"
                          ></app-nested-tree>

                          <app-input
                            [label]="'generics.cols.customerChannel' | translate"
                            formControlName="customerChannel"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="customerChannelSelection || []"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.assignedTo' | translate"
                            formControlName="assignedTo"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="allAssignedToSelection || []"
                          ></app-input>

                          <app-input
                            [label]="'generics.cols.messagesToReadSelection' | translate"
                            formControlName="messagesToRead"
                            type="selection"
                            [showNullOption]="true"
                            [selectionOptions]="messagesToReadSelection"
                          ></app-input>
                        </div>
                      </div>

                      <div class="customers-filter-card__footer">
                        <button
                          type="button"
                          class="customers-filter-card__btn customers-filter-card__btn--primary force-text-white"
                          (click)="doSearch()"
                        >

                          <span>{{ 'generics.cols.filter' | translate }}</span>
                        </button>

                        <button
                          type="button"
                          class="customers-filter-card__btn customers-filter-card__btn--secondary"
                          (click)="clearFilter()"
                        >
                          <i class="icon-ipe-clear" aria-hidden="true"></i>
                          <span>{{ 'generics.cols.clean' | translate }}</span>
                        </button>
                      </div>
                    </form>
                  }
                </div>

                @if (actions) {
                  <div class="customers-page__table-shell">
                    <app-tree
                      (clickRow)="openRowDetail($event)"
                      [dataSourceObservable]="dataSourceCustomers"
                      [columns]="CustomerColumns"
                      [actions]="actions?.customers"
                      [widgetOptions]="widgetOptions"
                    ></app-tree>
                  </div>
                }
              </div>
            }
          }
        }
      </mat-tab>
    }
  </mat-tab-group>
</div>

<ng-template
  #messageRowButton
  let-customClass='class'
  let-icon='icon'
  let-func='func'
  let-messagesToReadCount='messagesToReadCount'
  let-hideButton='hideButton'
>
  @if (!hideButton) {
    <app-button-badge
      (click)="$event.stopPropagation()"
      [icon]="icon"
      [iconClass]="customClass"
      [func]="func"
      [badgeNumber]="messagesToReadCount"
    ></app-button-badge>
  }
</ng-template>
